import { render, staticRenderFns } from "./bio.vue?vue&type=template&id=6964bc60&"
import script from "./bio.vue?vue&type=script&lang=js&"
export * from "./bio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports